import { INSTORE_SHIPPING_METHODS, TRANSACTION_TYPES } from 'constants/index';
import actionTypes from '../actions/actionTypes';

const DEFAULT_SHIPMENT_METHOD = 'SL1';

const INITIAL_STATE = {
  shipmentOptions: {
    sendsShipmentOptions: [],
    takesShipmentOptions: [],
  },
  transactionType: TRANSACTION_TYPES.TAKES,
  selectedShipmentMethodId: DEFAULT_SHIPMENT_METHOD,
  shipmentOptionsError: false,
  shipmentPromoError: null,
  loading: false,
};

const getMappedShipmentOptions = (payload, state) => {
  const { shipmentOptions, isInCircleLevel3orMore, isBGAssociate, transactionType } = payload;

  if (transactionType === TRANSACTION_TYPES.TAKES) {
    return {
      ...state.shipmentOptions,
      takesShipmentOptions: shipmentOptions,
    };
  }

  const brandProfile = isBGAssociate ? 'BG' : 'NM';
  const updatedShippingMethods = shipmentOptions.map((method) => {
    const shippingMethod = INSTORE_SHIPPING_METHODS[brandProfile].find((option) => option.id === method.shipmentOption);
    return {
      ...method,
      shipmentName: shippingMethod?.name,
      deliveryWindow: shippingMethod?.term,
    };
  });

  if (!isInCircleLevel3orMore) {
    return {
      ...state.shipmentOptions,
      sendsShipmentOptions: updatedShippingMethods,
    };
  }

  return {
    ...state.shipmentOptions,
    sendsShipmentOptions: updatedShippingMethods.map((option) => {
      if (updatedShippingMethods.shipmentOption === 'SL5') {
        return { ...option, deliveryCharges: 0 };
      }

      return option;
    }),
  };
};

const shipment = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.SHIPMENT_OPTIONS_LOADING:
      return { ...state, loading: true };

    case actionTypes.SHIPMENT_OPTIONS_SUCCESS:
      return {
        ...state,
        shipmentOptions: getMappedShipmentOptions(payload, state),
        loading: false,
      };

    case actionTypes.SHIPMENT_OPTIONS_ERROR:
      return { ...state, loading: false, shipmentOptionsError: true };

    case actionTypes.SHIPMENT_PROMO_ERROR:
      return { ...state, loading: false, shipmentPromoError: payload };

    case actionTypes.SHIPMENT_OPTIONS_ERROR_RESET:
      return { ...state, shipmentOptionsError: false };

    case actionTypes.SHIPMENT_PROMO_ERROR_RESET:
      return { ...state, shipmentPromoError: null };

    case actionTypes.SHIPMENT_RESET:
      return { ...INITIAL_STATE };

    case actionTypes.SHIPMENT_SET_SHIPMENT_METHOD_ID:
      return {
        ...state,
        selectedShipmentMethodId: payload,
      };

    case actionTypes.SHIPMENT_SET_TRANSACTION_TYPE:
      return {
        ...state,
        transactionType: payload,
      };

    default:
      return state;
  }
};

export default shipment;
